import React, { useState, useEffect } from "react";
import Image from "next/image";
import classNames from "classnames";
import MinusBtn from "@/icons/btn-minus.svg";
import PlusBtn from "@/icons/btn-plus.svg";

function ProductCard({ product, handleQtyUpdate, handleRemoveCartItem }) {
  const [productQty, setProductQty] = useState(() => product.quantity);

  useEffect(() => {
    if (
      product.quantity === productQty ||
      productQty > product.maximum_cart_quantity
    ) {
      return;
    }

    const timer = setTimeout(() => {
      product.quantity = productQty;
      handleQtyUpdate(product);
    }, 700);

    return () => clearTimeout(timer);
  }, [productQty]);

  const isIncrementDisabled = (quantity, product) => {
    return (
      quantity >= product.inventory ||
      quantity >= product.maximum_cart_quantity ||
      product.product_status_message
    );
  };

  return (
    <div>
      <div className="flex">
        <div className="relative w-[3.75rem] h-min aspect-square">
          <Image
            src={product?.main_picture}
            alt={product?.name}
            className="object-contain"
            fill
            sizes="33vw"
          />
        </div>

        <div className="w-full">
          <div className="ml-3">
            <div className="flex justify-between items-start">
              <div className="max-w-[15rem]">
                <h6 className="text-heading6">{product?.name}</h6>
              </div>
              <button
                className="w-[1.5rem]"
                onClick={() => handleRemoveCartItem(product)}
              >
                <Image
                  src="/assets/icons/x-circle.svg"
                  width={16}
                  height={16}
                  alt="remove product icon"
                  className=""
                />
              </button>
            </div>
            <p className="text-body2 text-[#7B838F]">
              {product?.variation && product.variation.name}
            </p>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-between mt-[1rem] items-center">
        <div className="flex items-center font-semibold w-2/6">
          <p className="text-body1">
            &#2547;
            {product?.offer_price > 0
              ? product?.offer_price
              : product?.unit_price}
          </p>
          {product?.offer_price > 0 && (
            <p className="text-body2 text-grayD4 line-through ml-[.5rem]">
              &#2547;{product?.unit_price}
            </p>
          )}
        </div>

        <div className="flex items-center pt-[2px] w-2/6 justify-end">
          <button
            disabled={productQty === 1}
            onClick={() => {
              setProductQty(productQty - 1);
            }}
            className="leading-none"
          >
            <MinusBtn
              className={classNames(
                product.quantity === 1 ? "text-[#7B838F]" : "text-[#0a101a]",
                "h-[1.5rem] w-[1.5rem]"
              )}
            />
          </button>
          <p className="mx-[1.1rem] text-heading5 w-[1.563rem] text-center">
            {productQty}
          </p>
          <button
            onClick={() => setProductQty(productQty + 1)}
            disabled={isIncrementDisabled(productQty, product)}
            className="leading-none"
          >
            <PlusBtn
              className={classNames(
                isIncrementDisabled(productQty, product)
                  ? "text-[#7B838F]"
                  : "text-[#0a101a]",
                "h-[1.5rem] w-[1.5rem]"
              )}
            />
          </button>
        </div>

        <div className="flex font-semibold w-2/6 justify-end">
          <span>&#2547;</span>
          <p className="text-body1">{product?.total}</p>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
